export const FILTER = 'FILTER';

// export const FETCH_FILTER = 'FETCH_FILTER';

export const FAILED_FILTER = 'FAILED_FILTER';

export const FETCH_ASSET_DETAILS = 'FETCH_ASSET_DETAILS';

export const ASSET_DETAILS = 'ASSET_DETAILS';

export const FAILED_ASSET_DETAILS = 'FAILED_ASSET_DETAILS';

export const FETCH_VENDER_BY_APP = 'FETCH_VENDER_BY_APP';

export const VENDER_BY_APP = 'VENDER_BY_APP';

export const FAILED_VENDER_BY_APP = 'FAILED_VENDER_BY_APP';

export const FETCH_CATEGORIES_BY_APP = 'FETCH_CATEGORIES_BY_APP';

export const CATEGORIES_BY_APP = 'CATEGORIES_BY_APP';

export const FAILED_CATEGORIES_BY_APP = 'FAILED_CATEGORIES_BY_APP';

export const FETCH_CATEGORY_SOFTWARE = 'FETCH_CATEGORY_SOFTWARE';

export const CATEGORY_SOFTWARE = 'CATEGORY_SOFTWARE';

export const FAILED_CATEGORY_SOFTWARE = 'FAILED_CATEGORY_SOFTWARE';

export const FETCH_ALL_INFORMATION_GRID = 'FETCH_ALL_INFORMATION_GRID';

export const ALL_INFORMATION_GRID = 'ALL_INFORMATION_GRID';

export const FAILED_ALL_INFORMATION_GRID = 'FAILED_ALL_INFORMATION_GRID';

export const FETCH_SOFTWARE_COUNT_BY_VENDOR = 'FETCH_SOFTWARE_COUNT_BY_VENDOR';

export const SOFTWARE_COUNT_BY_VENDOR = 'SOFTWARE_COUNT_BY_VENDOR';

export const FAILED_SOFTWARE_COUNT_BY_VENDOR = 'FAILED_SOFTWARE_COUNT_BY_VENDOR';

export const FETCH_DEVICE_COUNT_BY_VENDER = 'FETCH_DEVICE_COUNT_BY_VENDER';

export const DEVICE_COUNT_BY_VENDER = 'DEVICE_COUNT_BY_VENDER';

export const FAILED_DEVICE_COUNT_BY_VENDER = 'FAILED_DEVICE_COUNT_BY_VENDER';

export const SHOW_LOADER = 'SHOW_LOADER';


export const FETCH_UNMAPPED_APPLICATION = 'FETCH_UNMAPPED_APPLICATION';

export const UNMAPPED_APPLICATION = 'UNMAPPED_APPLICATION';

export const FAILED_UNMAPPED_APPLICATION = 'FAILED_UNMAPPED_APPLICATION';

export const FETCH_SKIPPED_APPLICATION = 'FETCH_SKIPPED_APPLICATION';

export const FETCH_DELETE_SKIPPED_APPLICATION = 'FETCH_DELETE_SKIPPED_APPLICATION';

export const DELETE_SKIPPED_APPLICATION = 'DELETE_SKIPPED_APPLICATION';

export const FAILED_DELETE_SKIPPED_APPLICATION = 'DELETE_SKIPPED_APPLICATION';

export const SKIPPED_APPLICATION = 'SKIPPED_APPLICATION';

export const FAILED_SKIPPED_APPLICATION = 'FAILED_SKIPPED_APPLICATION';

export const FETCH_MAPPED_APPLICATION = 'FETCH_MAPPED_APPLICATION';

export const SUCCESS_MAPPED_APPLICATION = 'SUCCESS_MAPPED_APPLICATION';

export const FAILED_MAPPED_APPLICATION = 'FAILED_MAPPED_APPLICATION';

export const REMOVE_MAPPED_APPLICATION_MSG = 'REMOVE_MAPPED_APPLICATION_MSG';

export const REMOVE_SKIPPED_APPLICATION_MSG = 'REMOVE_SKIPPED_APPLICATION_MSG';

export const SUCCESS_DELETE_SKIPPED_APPLICATION_MSG = 'SUCCESS_DELETE_SKIPPED_APPLICATION_MSG';

export const FAILED_DELETE_SKIPPED_APPLICATION_MSG = 'FAILED_DELETE_SKIPPED_APPLICATION_MSG';

export const FETCH_HARDWARE_SUMMARY = 'FETCH_HARDWARE_SUMMARY';
export const SUCCESS_HARDWARE_SUMMARY = 'SUCCESS_HARDWARE_SUMMARY';
export const FAILED_HARDWARE_SUMMARY = 'FAILED_HARDWARE_SUMMARY';
export const SUCCESS_LICENSE_STATISTICS = 'SUCCESS_LICENSE_STATISTICS';
export const FAILED_LICENSE_STATISTICS = 'FAILED_LICENSE_STATISTICS';
export const FETCH_LICENSE_STATISTICS = 'FETCH_LICENSE_STATISTICS';
export const UPDATE_LICENSE_STATISTICS = 'UPDATE_LICENSE_STATISTICS';
export const FETCH_SYSTEM_NAME = 'FETCH_SYSTEM_NAME';

export const SUCCESS_SYSTEM_NAME = 'SUCCESS_SYSTEM_NAME';

export const FAILED_SYSTEM_NAME = 'FAILED_SYSTEM_NAME';

export const FETCH_USER_WISE_DASHBOARD_ITAM = "FETCH_USER_WISE_DASHBOARD_ITAM";
export const SUCCESS_USER_WISE_DASHBOARD_ITAM = "SUCCESS_USER_WISE_DASHBOARD_ITAM";
export const FAILED_USER_WISE_DASHBOARD_ITAM = "FAILED_USER_WISE_DASHBOARD_ITAM";
export const FETCH_GET_SYSTEM_USER_NEMELIST="FETCH_GET_SYSTEM_USER_NEMELIST";
export const SUCCESS_GET_SYSTEM_USER_NEMELIST="SUCCESS_GET_SYSTEM_USER_NEMELIST";
export const FAILED_GET_SYSTEM_USER_NEMELIST="FAILED_GET_SYSTEM_USER_NEMELIST"

export const SELECTED_BIOS = "SELECTED_BIOS";


//software Details action types
export const FETCH_GET_0S_PUBLISHER_COUNT_DEATILS="FETCH_GET_0S_PUBLISHER_COUNT_DEATILS;"
export const SUCCESS_GET_0S_PUBLISHER_COUNT_DEATILS = 'SUCCESS_GET_0S_PUBLISHER_COUNT_DEATILS';
export const FAILED_GET_0S_PUBLISHER_COUNT_DEATILS="FAILED_GET_0S_PUBLISHER_COUNT_DEATILS";

export const  FETCH_GET_OS_PUBLISHER_DETAILS_WITH_NAME="FETCH_GET_OS_PUBLISHER_DETAILS_WITH_NAME";
export const SUCCESS_GET_PUBLISHER_DETAILS_WITH_NAME="SUCCESS_GET_PUBLISHER_DETAILS_WITH_NAME";
export const SUCCESS_GET_OS_DETAILS_WITH_NAME="SUCCESS_GET_OS_DETAILS_WITH_NAME";
export const FAILED_GET_OS_PUBLISHER_DETAILS_WITH_NAME="FAILED_GET_OS_PUBLISHER_DETAILS_WITH_NAME";

export const SUCCESS_GET_MANUFATURE_DETAILS_WITH_NAME="SUCCESS_GET_MANUFATURE_DETAILS_WITH_NAME";
export const SUCCESS_GET_ANTIVIRUS_DETAILS_WITH_NAME="SUCCESS_GET_ANTIVIRUS_DETAILS_WITH_NAME";
export const SUCCESS_GET_SYSTEM_TYPE_DETAILS_WITH_NAME="SUCCESS_GET_SYSTEM_TYPE_DETAILS_WITH_NAME";
export const EXPORTALL_LOADING="EXPORTALL_LOADING";